import React, { useState } from 'react';
import { createMedia, updateMedia, deleteMedia } from '../services/azureProjectMediaService';

const MediaTable = ({ projectId, media = [], onMediaChange }) => {
  const [newMedia, setNewMedia] = useState({ name: '', url: '', publikation: '', datum: '', public: false });
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAdd = async () => {
    if (!newMedia.name || !newMedia.publikation || !newMedia.datum) {
      setError('Name, Publikation und Datum sind erforderlich');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await createMedia(projectId, newMedia);
      onMediaChange([...media, result]);
      setNewMedia({ name: '', url: '', publikation: '', datum: '', public: false });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (mediaId, updatedData) => {
    setLoading(true);
    try {
      await updateMedia(projectId, mediaId, updatedData);
      onMediaChange(media.map(m => m.mediaId === mediaId ? { ...m, ...updatedData } : m));
      setEditingId(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (mediaId) => {
    if (!confirm('Artikel wirklich löschen?')) return;

    setLoading(true);
    try {
      await deleteMedia(projectId, mediaId);
      onMediaChange(media.filter(m => m.mediaId !== mediaId));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="media-table">
      <h4>Media</h4>
      
      {error && <div className="error-message">{error}</div>}

      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>URL</th>
            <th>Publikation</th>
            <th>Datum</th>
            <th>Public</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {media.map(item => (
            <tr key={item.mediaId}>
              {editingId === item.mediaId ? (
                <>
                  <td><input value={item.name} onChange={(e) => handleUpdate(item.mediaId, { ...item, name: e.target.value })} /></td>
                  <td><input value={item.url} onChange={(e) => handleUpdate(item.mediaId, { ...item, url: e.target.value })} /></td>
                  <td><input value={item.publikation} onChange={(e) => handleUpdate(item.mediaId, { ...item, publikation: e.target.value })} /></td>
                  <td><input type="date" value={item.datum} onChange={(e) => handleUpdate(item.mediaId, { ...item, datum: e.target.value })} /></td>
                  <td><input type="checkbox" checked={item.public} onChange={(e) => handleUpdate(item.mediaId, { ...item, public: e.target.checked })} /></td>
                  <td><button onClick={() => setEditingId(null)}>Abbrechen</button></td>
                </>
              ) : (
                <>
                  <td>{item.name}</td>
                  <td>{item.url ? <a href={item.url} target="_blank" rel="noopener noreferrer">Link</a> : '-'}</td>
                  <td>{item.publikation}</td>
                  <td>{item.datum}</td>
                  <td>{item.public ? 'Ja' : 'Nein'}</td>
                  <td>
                    <button onClick={() => setEditingId(item.mediaId)}>Bearbeiten</button>
                    <button onClick={() => handleDelete(item.mediaId)}>Löschen</button>
                  </td>
                </>
              )}
            </tr>
          ))}
          <tr>
            <td><input placeholder="Name" value={newMedia.name} onChange={(e) => setNewMedia({...newMedia, name: e.target.value})} /></td>
            <td><input placeholder="URL (optional)" value={newMedia.url} onChange={(e) => setNewMedia({...newMedia, url: e.target.value})} /></td>
            <td><input placeholder="Publikation" value={newMedia.publikation} onChange={(e) => setNewMedia({...newMedia, publikation: e.target.value})} /></td>
            <td><input type="date" value={newMedia.datum} onChange={(e) => setNewMedia({...newMedia, datum: e.target.value})} /></td>
            <td><input type="checkbox" checked={newMedia.public} onChange={(e) => setNewMedia({...newMedia, public: e.target.checked})} /></td>
            <td><button onClick={handleAdd} disabled={loading}>Hinzufügen</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MediaTable;